/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'comment': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M84.668 8.594H15.332c-5.605 0-10.254 4.61-10.254 10.215v47.207c0 5.605 4.648 10.156 10.254 10.156H48.75l23.613 14.824c.371.234.82.351 1.25.351.39 0 .781-.097 1.152-.293a2.342 2.342 0 001.211-2.05V76.172h8.692c5.605 0 10.254-4.551 10.254-10.156V18.809c0-5.606-4.649-10.215-10.254-10.215zm5.566 57.422c0 3.008-2.539 5.469-5.566 5.469H73.613a2.334 2.334 0 00-2.324 2.343v10.938l-20.605-12.93a2.373 2.373 0 00-1.25-.351H15.332c-3.028 0-5.567-2.461-5.567-5.469V18.809c0-3.027 2.54-5.527 5.567-5.527h69.336c3.027 0 5.566 2.5 5.566 5.527z"/>'
  }
})
